import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'mxjl-message-center',
  name: '消息中心',
  icon: '信',
  group: '新聚浪业务组件',
  description: '展示用户的系统通知、服务提醒和未读消息。',
  defaultProps: {
    title: '消息中心',
    emptyText: '暂时没有新消息',
    showUnreadOnly: false,
    showSettings: true
  }
}
